import React from 'react';
import {
  Row,
  Col,
} from 'react-grid-system';
import { getLocalizedText as text } from '@vp-dst/localization-util';
import withScreenClass, { withScreenClassPropTypes } from 'components/highOrder/withScreenClass';
import ScreenSizeUtil from 'utils/ScreenSizeUtil';

import SectionHeading from 'components/SectionHeading';
import HowItWorksStep from 'components/HowItWorksStep';
import Typography from 'components/vistaprintUILibrary/Typography';

import selectAProductIconSrc from 'images/icons/select-a-product.svg';
import chatBubbleIconSrc from 'images/icons/chat-bubble.svg';
import reviewIconSrc from 'images/icons/review.svg';


function HowItWorks(props) {
  const {
    screenClass,
  } = props;

  const isSmallScreen = ScreenSizeUtil.isSmallScreen(screenClass);

  return (
    <div
      style={{
        marginBottom: isSmallScreen ? 10 : 40,
      }}
    >
      <Row>
        <Col>
          <SectionHeading
            text={text('how-it-works')}
            alignment="center"
          />
        </Col>
      </Row>
      <Row
        style={{
          justifyContent: 'center', // this seems to work, but the fact that the api doesn't facilitate centering columns it makes me feel like it's wrong
        }}
      >
        <Col sm={4} style={{ paddingLeft: 10, paddingRight: 10 }}>
          <HowItWorksStep
            stepNumber={1}
            iconSrc={selectAProductIconSrc}
            title={text('select-a-product')}
            renderDescription={() => (
              <Typography
                text={text('choose-from-over-50-products')}
              />
            )}
          />
        </Col>
        <Col sm={4} style={{ paddingLeft: 10, paddingRight: 10 }}>
          <HowItWorksStep
            stepNumber={2}
            iconSrc={chatBubbleIconSrc}
            title={text('tell-us-what-you-want')}
            renderDescription={() => (
              <Typography
                text={text('fill-out-a-short-brief')}
              />
            )}
          />
        </Col>
        <Col sm={4} style={{ paddingLeft: 10, paddingRight: 10 }}>
          <HowItWorksStep
            stepNumber={3}
            iconSrc={reviewIconSrc}
            title={text('review-your-design')}
            renderDescription={() => (
              <div>
                <Typography
                  style={{
                    display: 'inline',
                  }}
                  text={text('schedule-time-with-your-designer')}
                />
              </div>
            )}
          />
        </Col>
      </Row>
    </div>
  );
}

HowItWorks.propTypes = {
  ...withScreenClassPropTypes,
};

export default withScreenClass(HowItWorks);



// WEBPACK FOOTER //
// ./src/components/HowItWorks.js